import React, { useEffect } from 'react';
import { Button, Chip, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import { APIData } from '../../constants/APIAdresses';
import { height } from '@mui/system';
import TagInputField from './TagInputField';

const TagList = ({ fileItem, offlineTags, maxRows, onDeleteTag, onAddTag, title, onAddFail, fullWidth }) => {
    const [localTags, setLocalTags] = React.useState(fileItem?.tags || offlineTags);
    const containerStyle = {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        height: onAddTag ? "auto" : "6.2em",
        overflowX: 'auto',
        width: fullWidth ? "100%" : '90%',
    };

    if (maxRows) {
        containerStyle.maxHeight = `${maxRows * 32}px`; // approx height per row
        containerStyle.overflowY = 'hidden';
    }

    const chipStyle = {
        maxWidth: '100%',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    };

    function onDelete(index, tag) {
        if (fileItem != null) {


            const API_URL = `${APIData.MEDIA}/file/${fileItem.id}/tags`;

            // if you ever want to support deleting multiple tags at once:
            const tags = [tag];

            // build query string
            const query = tags.map(t => `tags=${encodeURIComponent(t)}`).join('&');

            fetch(`${API_URL}?${query}`, {
                method: 'DELETE',
                credentials: 'include', // include cookies for session management
            })
                .then(response => {
                    if (response.ok) {
                        console.log(`✅ Tag "${tag}" deleted`);
                        onDeleteTag(tag, index); // callback to update UI
                    } else {
                        console.error("❌ Failed to delete tag:", response.statusText);
                    }
                })
                .catch(error => {
                    console.error("Error deleting tag:", error);
                });
        } else {
            // Local usage, just update the local state
            setLocalTags(prev => {
                const newTags = [...prev];
                newTags.splice(index, 1); // remove tag at index
                return newTags;
            });
            onDeleteTag(tag, index); // callback to update UI
            console.log(`Tag "${tag}" deleted locally`);
        }
    }
    function handleAddTag(tag) {
        onAddTag(tag);
        console.log(`Tag "${tag}" added`);
    }
    useEffect(() => {
        setLocalTags(fileItem?.tags || offlineTags);
    }, [fileItem?.tags, offlineTags]);
    return (
        <div style={containerStyle}>
            {title &&
                <Typography variant="subtitle2" color="text.secondary" style={{ width: '100%' }}>
                    {title}
                </Typography>
            }
            {onAddTag &&
                <div style={{ paddingTop: 8, width: '100%' }}>

                    <TagInputField
                        fileItem={fileItem}
                        onTagAdded={handleAddTag}
                        onFail={(tag) => {
                            console.error(`!!!!!!Failed to add tag: "${tag}"`);
                            onAddFail?.(tag);
                        }}
                    />
                </div>
            }
            {
                localTags?.length > 0 ?
                    <>
                        {
                            localTags?.map((tag, idx) => (
                                <Chip
                                    key={`tag_${idx}`}
                                    label={
                                        <span style={chipStyle} title={tag}>#{tag}</span>
                                    }
                                    onDelete={() => { onDelete(idx, tag) }}
                                    size="small"
                                />
                            ))
                        }
                    </> :
                    <div style={{}}>

                        <Typography
                            variant="caption"
                            color="text.secondary"
                        >
                            Keine Tags
                        </Typography>
                    </div>
            }
        </div >
    );
};

export default TagList;
